import React, { useState, useEffect } from 'react';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { jwtDecode } from 'jwt-decode';
import { api } from '../../config';
import "./Article.css";
import { toast } from 'react-toastify';
const CategoryForm = () => {

    const [showForm, setShowForm] = useState(false);
    const [categoryDescription, setCategoryDescription] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [categories, setCategories] = useState([]);
    const [categoryLink, setCategoryLink] = useState('');
    const [mode, setMode] = useState('add'); // 'add' or 'update'
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [formData, setFormData] = useState({
      category_name: '',
      image_url: '',
      description: '',
      category_id: '',
    });
  
function validateForm(formData) {
  let isValid = true;
  const errors = {};
// console.log(formData);
// console.log(!formData?.image_url.trim());
  if (!formData?.category_name) {
    if (!formData?.category_name.trim()) {
      errors.category_name = "اسم المجلة مطلوب.";
      isValid = false;
    }else{
    errors.category_name = "اسم المجلة مطلوب.";
    isValid = false;
    }
  }


  if (!formData?.image_url) {
    if (!formData?.image_url?.trim()) {
    errors.image_url = "رابط صورة المجلة مطلوب.";
    isValid = false;
    }else{
      errors.image_url = "رابط صورة المجلة مطلوب.";
      isValid = false;
    }
  }

  return { isValid, errors };
}
  const modules = {
        toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
    
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
    
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        
    
        ['clean']     ,
       
        // remove formatting button
        ],
    };
    
    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
        'list', 'bullet', 'indent',
        'link', 'image', 'video',
        'align', 'direction', 'color', 'background'
    ];

  useEffect(() => {
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    checkTokenExpiration();
    if(!showForm) return;
    getCategories();
  }, [showForm]);



  
  const getCategories = async () => {
    try {
        const response = await fetch(`${api}/book_author/category`, { method: 'GET' });
        const data = await response.json();
        setCategories(data);
        
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
};
  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
      if (decodedToken.exp < currentTime) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username);
  };

  const handleChange = (e) => {
    const token = localStorage.getItem('token');
    let decodedToken = '';
    if (token) {
       decodedToken = (token);
    }

    if (e.target.name === 'category') {
       if (e.target.value == '') { resetForm(); return; }
      categories.forEach((category) => {
        if (category.category_id == e.target.value) {
          handleEditCategoryClick(category);
        }
      })
    }
    setFormData({ ...formData, [e.target.name]: e.target.value,token: decodedToken});
    
    // Validate the form
    const { isValid, errors } = validateForm({ ...formData, [e.target.name]: e.target.value });
    setFormErrors(errors);
  };

  const resetForm = () => {
    setFormData({
      category_name: '',
      description: '',
      image_url: '',
      category_id: '',
    });
    setSelectedCategoryId(null);
    setCategoryName('');
    setCategoryLink('');
    setCategoryDescription('');
    setIsUpdating(false);
    setMode('add');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, errors } = validateForm({ ...formData, [e.target.name]: e.target.value });

    if (!isValid) {
      Object.values(errors).forEach(error => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    }); // Here you could set these errors to state and display them in the form
        return;
    }
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/index';
      return;
    }
    const decodedToken = (token);
    try {
      const response = await fetch(`${api}/book_author/newCategory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}`
        },
        body: JSON.stringify({
          category_name: categoryName,
          description: categoryDescription,
          image_url: categoryLink,
          token: decodedToken,
        }),
      });
      let data = await response.json();
      
      if (data.message === 'Category created successfully') {
        toast.success('تم إضافة المجلة بنجاح');
      } else {
        toast.error(data.message || 'حدث خطأ، الرجاء المحاولة مره اخرى');
      }
    } catch (error) {
      console.error(error);
      
    }
    setShowForm(false);
    getCategories();  // Refresh categories list
    setCategoryName(''); // Clear the form fields
    setCategoryLink(''); 
    setCategoryDescription('');
  };
  
  const handleEditCategoryClick = async (category) => {  
    try {
    const response = await fetch(`${api}/book_author/category/${category.category_id}`, { method: 'GET' });
    const data = await response.json();
    setCategoryName(data[0].category_name);
    setCategoryLink(data[0].image_url);
    setCategoryDescription(data[0].description);
    setSelectedCategoryId(data[0].category_id);
    setShowForm(true);
    setMode('update');
   
} catch (error) {
    console.error('Error fetching categories:', error);
}
     
  };

  const handleSubmitUpdateCategory = async (e) => {
    e.preventDefault();
    let valdit = {
      category_name: categoryName,
      image_url: categoryLink,
      description: categoryDescription,
    };
    const { isValid, errors } = validateForm(valdit);
    
        if (!isValid) {
          Object.values(errors).forEach(error => {
            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
        }); // Here you could set these errors to state and display them in the form
            return;
        }
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/index';
      return;
    }
    const decodedToken = (token);
    try {
      const response = await fetch(`${api}/book_author/category/${selectedCategoryId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}`
        },
        body: JSON.stringify({
          category_name: categoryName,
          image_url: categoryLink,
          description: categoryDescription,
          token: decodedToken,
        }),
      });
      let data = await response.json();
      
      if (data.message === 'Category updated successfully') {
        toast.success('تم تحديث المجلة بنجاح');
      } else {
        toast.error(data.message || 'حدث خطأ، الرجاء المحاولة مره اخرى');
      }
    } catch (error) {
      console.error(error);
      
    }
    resetForm();
    getCategories();  // Refresh categories list after update
  };

  return (
    <span>
      {showForm ? (
        <form className='book-details-form' onSubmit={handleSubmit}>
          <div className='book-details-form-item'>
            <label>المجلة (للتعديل):</label>
            <select name="category" style={{width:"100%",height:"40px"}}  value={formData.category} onChange={handleChange}>
              <option value="">اختر...</option>
              {categories.map((category) => {
                if (category.category_id === 0) {
                  return null; // Skip rendering this option
                }
                return (
                  <option key={category.category_id} value={category.category_id}>
                    {category.category_name}
                  </option>
                );
              })}
            </select>
            <div className='form-buttons'></div>
          </div>
          <div className='book-details-form-item'>
            <label>{mode === 'add' ? 'اسم المجلة:' : 'تحديث اسم المجلة:'}<span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='category' value={categoryName} onChange={(e) => setCategoryName(e.target.value)} placeholder={mode === 'update' ? 'أدخل اسم المجلة' : 'أسم المجلة'} required={formData.category !== ''} />
            {formErrors.category && <span className="error">{formErrors.category}</span>}
          </div>
          <div className='book-details-form-item'>
            <label>{mode === 'add' ? 'وصف المجلة:' : 'تحديث وصف المجلة:'}<span style={{ color: 'red' }}>*</span></label>
            <ReactQuill
              style={{
                borderRadius: "7px",
                border: "1px solid"
              }}
              theme="snow"
              modules={modules}
              formats={formats}
              value={categoryDescription}
              onChange={setCategoryDescription}
            />
          </div>
          <div className='book-details-form-item'>
            <label>{mode === 'add' ? 'رابط صورة المجلة:' : 'تحديث رابط صورة المجلة:'}<span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='image_url' value={categoryLink} onChange={(e) => setCategoryLink(e.target.value)} placeholder={mode === 'update' ? 'رابط صورة المجلة' : 'اسم رابط صورة المجلة'} required />
          </div>
          <div className='form-buttons'>
            <button onClick={mode === 'add' ? handleSubmit : handleSubmitUpdateCategory}> {mode === 'add' ? 'إضافة المجلة' : 'تحديث المجلة'}</button>
            <button  type="button" onClick={() => setShowForm(false)}>الغاء</button>
          </div>
        </form>
      ) : (
        <button className="new-book-btn" onClick={() => setShowForm(true)}>إضافة مجلة </button>
      )}
    </span>
  );
};

export default CategoryForm;

